import { useInfiniteQuery } from 'react-query';
import { documentsService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetDocuments = () => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.documents(),
    queryFn: async ({ pageParam = 0 }) => {
      return documentsService.getDocuments({
        pageParam,
        pageSizeParam: 30,
      });
    },

    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
